import { Flex } from '@teamsparta/stack-flex';

import type { CommunityPostComment } from '@/api/community/comment';

import { SubComment } from '../SubComment';

interface Props {
  postId: string;
  subComments: Omit<CommunityPostComment, 'subComments'>[];
}

export function SubComments({ postId, subComments }: Props) {
  return (
    <Flex.Column gap={30} fullWidth padding='0 0 0 32px'>
      {subComments.map((subComment) => (
        <SubComment key={subComment._id} postId={postId} {...subComment} />
      ))}
    </Flex.Column>
  );
}
